import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  endingSoon: {
    defaultMessage: 'Ending Soon',
  },
  newlyListed: {
    defaultMessage: 'Newly Listed',
  },
  allOffers: {
    defaultMessage: 'All Offers',
  },
  openOffers: {
    defaultMessage: 'Open Offers',
  },
  endedOffers: {
    defaultMessage: 'Ended Offers',
  },
  acceptedOffers: {
    defaultMessage: 'Accepted Offers',
  },
  rejectedOffers: {
    defaultMessage: 'Rejected Offers',
  },
  latest: {
    defaultMessage: 'Latest',
  },
  oldest: {
    defaultMessage: 'Oldest',
  },
  createNewOffer: {
    defaultMessage: 'Create new offer',
  },
});
